<template>
  <v-row class="ma-10 elevation-5 fill-height" justify="space-around">
    <v-card class="ma-10" width="100%" flat tile>
      <v-card-title>Permissions for Sales Rep </v-card-title>
      <v-row class="mx-5">
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Dashboard
            </v-card-title>
            <v-card-text>
              <v-switch
                inset
                v-model="permissions"
                label="View"
                value="VIEW_DASHBOARD"
              ></v-switch>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Business
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_BUSINESS"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Client
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_CLIENT"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_CLIENT"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_CLIENT"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Contract
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_CONTRACT"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_CONTRACT"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_CONTRACT"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Transaction
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_TRANSACTION"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_TRANSACTION"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_TRANSACTION"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Listing
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_LISTING"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_LISTING"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_LISTING"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Employee
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_EMPLOYEE"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_EMPLOYEE"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_EMPLOYEE"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_EMPLOYEE"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Priority Listing
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_PRIORITY_LISTING"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_PRIORITY_LISTING"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_PRIORITY_LISTING"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_PRIORITY_LISTING"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Free Listing
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_FREE_LISTING"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_FREE_LISTING"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_FREE_LISTING"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_FREE_LISTING"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Bold Listing
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_BOLD_LISTING"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_BOLD_LISTING"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_BOLD_LISTING"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_BOLD_LISTING"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              View
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_VIEW"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Quote
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_QUOTE"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Booking Invoice
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_BOOKING_INVOICE"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_BOOKING_INVOICE"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_BOOKING_INVOICE"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_BOOKING_INVOICE"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Blog
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_BLOG"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_BLOG"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_BLOG"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_BLOG"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Group
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_GROUP"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_GROUP"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_GROUP"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_GROUP"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Category
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_CATEGORY"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_CATEGORY"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_CATEGORY"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_CATEGORY"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Xref
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_XREF"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_XREF"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_XREF"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_XREF"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Suburb
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_SUBURB"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_SUBURB"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_SUBURB"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_SUBURB"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Region
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_REGION"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_REGION"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_REGION"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_REGION"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              Keyword
            </v-card-title>
            <v-card-text>
              <v-row
                ><v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="View"
                    value="VIEW_KEYWORD"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    value="CREATE_KEYWORD"
                    label="Create"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Edit"
                    value="EDIT_KEYWORD"
                  ></v-switch
                ></v-col>
                <v-col>
                  <v-switch
                    inset
                    v-model="permissions"
                    label="Delete"
                    value="DELETE_KEYWORD"
                  ></v-switch
                ></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import { axios } from '../../../utils'
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['permissions/getAllPermissions']),
    permissions: {
      get() {
        return this['permissions/getAllPermissions']
      },
      set(value) {
        this['permissions/setPermissions'](value)
      }
    }
  },

  methods: {
    ...mapActions(['permissions/setPermissions'])
  },
  watch: {
    permissions: function(value) {
      axios
        .put('/api/change-sr-permissions', { permissions: value })
        .then(({ data }) => console.log(data))
        .catch(err => console.log(err))
    }
  }
}
</script>

<style></style>
